import {
  array,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from "prop-types";

import styled from "styled-components/macro";

import extendedFieldHooks from "ExtendedFields/selectorHooks";
import classNames from "classnames";
import { motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon";

export default function AdditionalInfoListItem({
  item: { title, icon, fromProfile, required, id } = {},
  onPointerDown,
  allItems = [],
  isActiveItem,
  index,
  disabled,
}) {
  const [, setFieldId] = extendedFieldHooks.useSelectedFieldId();
  const [, setIsNavigating] = extendedFieldHooks.useIsNavigating();

  const editItem = () => {
    setFieldId(id);
    setIsNavigating(false);
  };

  return (
    <ItemWrapper
      data-cy={"FieldDragListItem_ItemContainer"}
      className={classNames({
        dragging: isActiveItem,
        isFirstChild: index === 0,
      })}
      onClick={editItem}
    >
      <Inside>
        <Icon>
          <FnrIcon icon={icon} />
        </Icon>
        <Title>{title}</Title>
        {fromProfile && (
          <ProfileIcon title="Updates profile field">
            <FnrIcon fas fa-id-badge />
          </ProfileIcon>
        )}
        <Spacer />
        {required && (
          <Required>
            <FnrIcon fas fa-asterisk />
          </Required>
        )}
        {allItems.length > 1 && !disabled && (
          <DragHandle
            onPointerDown={onPointerDown}
            onClick={(e) => {
              // If the containing element has a click event, we don't want it to fire.
              e.stopPropagation();
            }}
            data-cy="ItemWithHandle__SortHandle"
          >
            <FnrIcon fas fa-sort />
          </DragHandle>
        )}
      </Inside>
    </ItemWrapper>
  );
}

AdditionalInfoListItem.propTypes = {
  item: shape({
    title: string,
    icon: string,
    fromProfile: bool,
    required: bool,
    id: oneOfType([string, number]),
  }),
  onPointerDown: func,
  allItems: array,
  isActiveItem: bool,
  index: number,
  disabled: bool,
};

const ItemWrapper = styled(motion.div)`
  cursor: pointer;
  position: relative;
  padding: 2px;
  background: #fff;
  border-radius: 6px;
  &:not(.isFirstChild) {
    margin-top: 2px;
  }
  &.dragging {
    cursor: grabbing;
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 3px;
  }
`;
const Icon = styled.div`
  width: 20px;
  text-align: center;
`;
const Title = styled.div`
  margin-left: 10px;
`;
const ProfileIcon = styled.div`
  color: #828c8d;
  margin-left: 10px;
  font-size: 12px;
`;
const Spacer = styled.div`
  flex-grow: 1;
  min-width: 10px;
`;
const Required = styled.div`
  width: 20px;
  text-align: center;
  opacity: 0.8;
  font-size: 14px;
  transition: opacity 0.2s, transform 0.2s;
  ${ItemWrapper}:hover & {
    opacity: 0;
    transform: scale(0.7);
  }
`;
const DragHandle = styled.div`
  position: absolute;
  right: 10px;
  width: 20px;
  text-align: center;
  cursor: grab;
  font-size: 24px;
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.2s, transform 0.2s;
  ${ItemWrapper}:hover & {
    opacity: 1;
    transform: none;
  }
  &:active {
    cursor: grabbing;
  }
`;
const Inside = styled.div`
  position: relative;
  display: flex;
  font-weight: 400;
  align-items: center;
  background: #f1f4f6;
  border-radius: 4px;
  padding: 10px;
`;
